import { render, staticRenderFns } from "./parameter_configuration.vue?vue&type=template&id=cb12b12a"
import script from "./parameter_configuration.vue?vue&type=script&lang=js"
export * from "./parameter_configuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb12b12a')) {
      api.createRecord('cb12b12a', component.options)
    } else {
      api.reload('cb12b12a', component.options)
    }
    module.hot.accept("./parameter_configuration.vue?vue&type=template&id=cb12b12a", function () {
      api.rerender('cb12b12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/parameter_configuration/parameter_configuration.vue"
export default component.exports